import { h } from 'vue';
import { type IconComponent } from './types';

export function createIcon(
  name: string,
  namePascal: string,
  children: [string, Record<string, any>][],
): IconComponent {
  return ({ color = 'currentColor', size = 24 }, { attrs, slots }) => {
    return h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        stroke: 'none',
        width: size,
        height: size,
        ...attrs,
        fill: color,
        'data-icon': name,
      },
      [...children.map((item) => h(...item)), ...(slots.default ? [slots.default()] : [])],
    );
  };
}

